// Added polyfill to solive issue with ChakraProvider not loading when running on android device
import "react-app-polyfill/stable";
// import ReactDOM from "react-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.scss";
import AppProviders from "./providers/AppProviders";
import reportWebVitals from "./reportWebVitals";

function ErrorFallback({ error }) {
  return (
    <div
      role="alert"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        paddingTop: "5rem",
      }}
    >
      <div
        style={{
          maxWidth: "30rem",
          marginTop: "1rem",
          textAlign: "center",
          color: "#475569",
          fontFamily: "Inter, sans-serif",
          borderRadius: "4px",
          padding: "2rem",
          border: "solid 1px #cbd5e1",
        }}
      >
        <p style={{ fontSize: "18px", color: "#b91c1c" }}>
          Ah bummer, this failed to load.
        </p>

        <p style={{ fontSize: "12px", color: "#94a3b8" }}>
          If you are seeing this, then we are sorry! Try a refresh and please
          send us a message if this persists.
        </p>
      </div>
    </div>
  );
}

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <BrowserRouter>
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
